import { useTheme } from '@mui/material';
import isNumber from 'lodash/isNumber';

import { Icons, Tooltip, Typography, Stack } from '@cast/design-system';

import { Money } from 'components/money';

type Props = {
  savings: number | undefined;
};

export const SavingsCell = ({ savings }: Props) => {
  const hasSavings = isNumber(savings);
  const { palette } = useTheme();

  if (hasSavings && savings === 0) {
    return (
      <Tooltip
        title={
          <Stack direction="row" gap={4}>
            <Icons.CheckCircle
              color={palette.green[500]}
              weight="fill"
              size={16}
            />
            <Typography typography="P12R">
              This workload is fully optimized.
            </Typography>
          </Stack>
        }
        placement="top"
      >
        <Icons.CheckCircle
          color={palette.green[500]}
          weight="fill"
          size={16}
          data-testid="savings"
          data-savings={savings}
        />
      </Tooltip>
    );
  }

  const isPositive = hasSavings && savings >= 0;

  return (
    <Typography
      variant="P12B"
      color={isPositive ? 'green.700' : 'grey.900'}
      component="span"
      data-testid="savings"
      data-savings={savings ?? 0}
    >
      <Money
        amount={hasSavings ? Math.abs(savings) : undefined}
        dashesIfUndefined
      />
    </Typography>
  );
};
